export const COMPANY_TAG_VALUES = [
  'AGENCY',
  'BRAND',
  'FESTIVAL',
  'INSURANCE',
  'LEGAL',
  'MANAGEMENT',
  'MARKETING',
  'MEDIA',
  'ONLINE',
  'PRINT',
  'PUBLISHER',
  'PROMOTER_COPRO',
  'PROMOTER_FESTIVAL',
  'PROMOTER_TOURING',
  'RADIO',
  'RECORD_LABEL',
  'SUPPLIER',
  'SUPPLIER_REBATE',
  'TICKETING',
  'TV',
  'VENUE_OPERATOR',
] as const;
